import React from 'react';
import type { ICellRendererParams } from 'ag-grid-community';

type Params = ICellRendererParams & {
  maxAbs?: number;
  negColor?: string;
  posColor?: string;
};

const clamp01 = (x: number) => (x < 0 ? 0 : x > 1 ? 1 : x);

export default function RightOnlyBarCell(params: Params) {
  const raw = Array.isArray(params.value) ? params.value[0] : params.value;
  const v = Number(raw) || 0;

  if (v === 0) {
    return null;
  }

  const maxAbs = Number(params.maxAbs) || 1;
  const pct = clamp01(Math.abs(v) / maxAbs) * 100;
  const color =
    v < 0 ? params.negColor || '#e74c3c' : params.posColor || '#3498db';

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: 40,
        display: 'flex',
        alignItems: 'center',
        padding: '4px 0',
      }}
    >
      {/* Bar */}
      <div
        style={{
          position: 'relative',
          height: '100%',
          width: `${pct}%`,
          background: color,
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
          transition: 'width 250ms ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontWeight: 600,
          fontSize: 13,
          fontFamily: 'Segoe UI, Roboto, sans-serif',
          padding: '0 4px',
        }}
      >
      </div>
      <span style={{ marginLeft: 8, fontWeight: 600, fontFamily: 'Segoe UI, Roboto, sans-serif' }}>{v.toFixed(1)}%</span>
    </div>
  );
}
